<!-- <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Tender Overview</h2>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutGap="24px" class="mt-3">
      <div fxFlex>
        <p><mat-icon color="primary">badge</mat-icon> <strong>ID:</strong> {{ tenderDetails.tenderId }}</p>
        <p><mat-icon color="primary">style</mat-icon> <strong>Type:</strong> {{ tenderDetails.tenderType }}</p>
      </div>
      <div fxFlex>
        <p><mat-icon color="primary">payment</mat-icon> <strong>Payment Mode:</strong> {{ tenderDetails.paymentMode }}</p>
      </div>
    </div>
  </mat-card>
  
  <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Covers Information</h2>
    <mat-divider></mat-divider>
    <table mat-table [dataSource]="tenderDetails.covers" class="mat-elevation-z4 mt-4 w-full">
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef>Cover No</th>
        <td mat-cell *matCellDef="let element">{{ element.number }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Cover Type</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container>
      <ng-container matColumnDef="documentType">
        <th mat-header-cell *matHeaderCellDef>Document Type</th>
        <td mat-cell *matCellDef="let element">{{ element.documentType }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="['number', 'type', 'documentType']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['number', 'type', 'documentType'];"></tr>
    </table>
  </mat-card>
  
  <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Fees & EMD</h2>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutGap="24px" class="mt-3">
      <div fxFlex>
        <p><strong>Total Fee:</strong> ₹{{ tenderDetails.fee.totalFee }}</p>
        <p><strong>Processing Fee:</strong> ₹{{ tenderDetails.fee.processingFee }}</p>
      </div>
      <div fxFlex>
        <p><strong>EMD Amount:</strong> ₹{{ tenderDetails.emd.amount }}</p>
        <p><strong>Type:</strong> {{ tenderDetails.emd.type }}</p>
      </div>
    </div>
  </mat-card>
  
  <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Work Details</h2>
    <mat-divider></mat-divider>
    <p class="mt-3">{{ tenderDetails.workTitle }}</p>
    <p><strong>Estimated Value:</strong> ₹{{ tenderDetails.value }}</p>
    <p><strong>Location:</strong> {{ tenderDetails.location }}</p>
  </mat-card>
  
  <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Important Dates</h2>
    <mat-divider></mat-divider>
    <div fxLayout="row wrap" fxLayoutGap="24px" class="mt-3">
      <div fxFlex="45%">
        <p><strong>Published:</strong> {{ tenderDetails.bidDates.published }}</p>
        <p><strong>Bid Start:</strong> {{ tenderDetails.bidDates.bidStart }}</p>
      </div>
      <div fxFlex="45%">
        <p><strong>Bid End:</strong> {{ tenderDetails.bidDates.bidEnd }}</p>
        <p><strong>Opening:</strong> {{ tenderDetails.bidDates.openDate }}</p>
      </div>
    </div>
  </mat-card>
  
  <mat-card class="mb-6 p-4">
    <h2 class="text-xl font-semibold mb-2">Documents</h2>
    <mat-divider></mat-divider>
    <ul class="mt-3">
      <li *ngFor="let doc of tenderDetails.documents">
        <mat-icon>insert_drive_file</mat-icon> {{ doc.name }} ({{ doc.size }})
      </li>
    </ul>
  </mat-card>
   -->

   <mat-card class="tender-section">
    <mat-card-title>Tender Details</mat-card-title>
    <mat-divider></mat-divider>
    <div class="section-grid">
      <div><span class="label">Tender ID:</span> {{ tenderDetails.tenderId }}</div>
      <div><span class="label">Type:</span> {{ tenderDetails.tenderType }}</div>
      <div><span class="label">Form of Contract:</span> {{ tenderDetails.formOfContract }}</div>
      <div><span class="label">Category:</span> {{ tenderDetails.category }}</div>
      <div><span class="label">Payment Mode:</span> {{ tenderDetails.paymentMode }}</div>
      <div><span class="label">Multi Currency Fee:</span> {{ tenderDetails.multiCurrencyAllowed ? 'Yes' : 'No' }}</div>
    </div>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Covers Information</mat-card-title>
    <mat-divider></mat-divider>
    <table mat-table [dataSource]="tenderDetails.covers" class="mat-elevation-z2 full-width-table">
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef>Cover No</th>
        <td mat-cell *matCellDef="let element">{{ element.number }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container>
      <ng-container matColumnDef="docType">
        <th mat-header-cell *matHeaderCellDef>Document Type</th>
        <td mat-cell *matCellDef="let element">{{ element.documentType }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="coverColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: coverColumns;"></tr>
    </table>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Fee & EMD Details</mat-card-title>
    <mat-divider></mat-divider>
    <div class="section-grid">
      <div><span class="label">Total Fee:</span> ₹{{ tenderDetails.fee.total }}</div>
      <div><span class="label">Processing Fee:</span> ₹{{ tenderDetails.fee.processing }}</div>
      <div><span class="label">EMD Amount:</span> ₹{{ tenderDetails.emd.amount }}</div>
      <div><span class="label">EMD Fee Type:</span> {{ tenderDetails.emd.type }}</div>
    </div>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Work Item</mat-card-title>
    <mat-divider></mat-divider>
    <p><span class="label">Title:</span> {{ tenderDetails.work.title }}</p>
    <p><span class="label">Description:</span> {{ tenderDetails.work.description }}</p>
    <div class="section-grid">
      <div><span class="label">Location:</span> {{ tenderDetails.work.location }}</div>
      <div><span class="label">Pincode:</span> {{ tenderDetails.work.pincode }}</div>
      <div><span class="label">Estimated Value:</span> ₹{{ tenderDetails.work.value }}</div>
      <div><span class="label">Duration:</span> {{ tenderDetails.work.period }} Days</div>
    </div>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Important Dates</mat-card-title>
    <mat-divider></mat-divider>
    <div class="section-grid">
      <div><span class="label">Published:</span> {{ tenderDetails.dates.published }}</div>
      <div><span class="label">Bid Start:</span> {{ tenderDetails.dates.bidStart }}</div>
      <div><span class="label">Bid End:</span> {{ tenderDetails.dates.bidEnd }}</div>
      <div><span class="label">Opening Date:</span> {{ tenderDetails.dates.opening }}</div>
    </div>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Documents</mat-card-title>
    <mat-divider></mat-divider>
    <mat-list>
      <mat-list-item *ngFor="let doc of tenderDetails.documents">
        <span matLine>{{ doc.name }}</span>
        <span matLine class="text-xs text-gray-600">{{ doc.size }} KB</span>
      </mat-list-item>
    </mat-list>
  </mat-card>
  
  <mat-card class="tender-section">
    <mat-card-title>Tender Inviting Authority</mat-card-title>
    <mat-divider></mat-divider>
    <p><span class="label">Name:</span> {{ tenderDetails.authority.name }}</p>
    <p><span class="label">Address:</span> {{ tenderDetails.authority.address }}</p>
  </mat-card>
  